exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dB-CCpWN2b8jGWiMxXOUi .box{border:1px dotted dycolor-internal(!campaign-notificaton-border,@primary)}.dB-CCpWN2b8jGWiMxXOUi .box .icon-container>.fa-icon{color:dycolor-internal(!campaign-notificaton-border,@primary)}.dB-CCpWN2b8jGWiMxXOUi .box .btn.btn-link{color:dycolor-internal(!campaign-notificaton-button,@secondary)}.dB-CCpWN2b8jGWiMxXOUi .box .btn.btn-outline-white{color:dycolor-internal(!campaign-notification-filled-text,@theme-white);border-color:dycolor-internal(!campaign-notification-filled-text,@theme-white)}.dB-CCpWN2b8jGWiMxXOUi .box.filled{background-color:dycolor-internal(!campaign-notificaton-filled,@secondary);color:dycolor-internal(!campaign-notification-filled-text,@theme-white)}.dB-CCpWN2b8jGWiMxXOUi .box.filled .fa-icon{color:dycolor-internal(!campaign-notification-filled-text,@theme-white)}\n", ""]);

// exports
exports.locals = {
	"root": "dB-CCpWN2b8jGWiMxXOUi"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules=true!./~/gotu-vue-dycolor/dist/lib/dycolor-loader.js?colors!./~/sass-loader/lib/loader.js?outputStyle=compressed!./src/components/rabbit/campaign-notification/CampaignNotification.scss
// module id = 894
// module chunks = 1